import type {
  FormLabelProps as ChakraFormLabelProps,
  ThemingProps,
} from '@chakra-ui/react';
import { FormLabel as ChakraFormLabel } from '@chakra-ui/react';
import React from 'react';

import type { OmitChakraProps } from '../../utils/typeUtils';
import { withChakraAs } from '../../utils/withChakraAs';

export type FormLabelProps = OmitChakraProps<
  ChakraFormLabelProps,
  keyof ThemingProps
>;

export const FormLabel = withChakraAs<FormLabelProps, 'div'>((props) => {
  return <ChakraFormLabel {...props} />;
});
